import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/domains';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
import { EssayQuestionReport, FillInBlankQuestionReport, GeneralInformationReport, MatchingQuestionReport, MultipleChoiceQuestionReport, SingleChoiceQuestionReport } from '../../../core';
import { QuestionType } from '@module/form';
export var REPORT_API = 'REPORT_API';
export var ReportApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(ReportApi, _AxiosApi);

  var _super = _createSuper(ReportApi);

  function ReportApi(axiosInstance) {
    var _this;

    _classCallCheck(this, ReportApi);

    _this = _super.call(this, 'assignments', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(ReportApi, [{
    key: "getGeneralInformationReport",
    value: function () {
      var _getGeneralInformationReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(assignmentId) {
        var jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.get("".concat(this.url, "/").concat(assignmentId, "/general-information-reports"));

              case 3:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                return _context.abrupt("return", GeneralInformationReport.fromJson(parsedResponseBody.data));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function getGeneralInformationReport(_x) {
        return _getGeneralInformationReport.apply(this, arguments);
      }

      return getGeneralInformationReport;
    }()
  }, {
    key: "getQuestionReports",
    value: function () {
      var _getQuestionReports = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(assignmentId, sectionId) {
        var isBookmarked,
            jsonResponse,
            parsedResponseBody,
            questionReports,
            filteredQuestionReports,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isBookmarked = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
                _context2.prev = 1;
                _context2.next = 4;
                return this.axios.get("".concat(this.url, "/").concat(assignmentId, "/question-reports"), {
                  params: {
                    sectionId: sectionId,
                    isBookmarked: isBookmarked
                  }
                });

              case 4:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", Result.fail(parsedResponseBody.message));

              case 8:
                questionReports = parsedResponseBody.data.map(function (questionReport) {
                  switch (questionReport.type) {
                    case QuestionType.SingleChoice:
                      {
                        return SingleChoiceQuestionReport.fromJson(questionReport);
                      }

                    case QuestionType.MultipleChoice:
                      {
                        return MultipleChoiceQuestionReport.fromJson(questionReport);
                      }

                    case QuestionType.FillInBlank:
                      {
                        return FillInBlankQuestionReport.fromJson(questionReport);
                      }

                    case QuestionType.Essay:
                      {
                        return EssayQuestionReport.fromJson(questionReport);
                      }

                    case QuestionType.Matching:
                      {
                        return MatchingQuestionReport.fromJson(questionReport);
                      }
                  }
                });
                filteredQuestionReports = questionReports.filter(function (questionReport) {
                  return !!questionReport;
                });
                return _context2.abrupt("return", Result.combineArray(filteredQuestionReports));

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 13]]);
      }));

      function getQuestionReports(_x2, _x3) {
        return _getQuestionReports.apply(this, arguments);
      }

      return getQuestionReports;
    }()
  }, {
    key: "updateQuestionReportBookmark",
    value: function () {
      var _updateQuestionReportBookmark = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(assignmentId, questionReportId) {
        var _updateQuestionReportBookmark2, jsonResponse;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _updateQuestionReportBookmark2 = "".concat(this.url, "/").concat(assignmentId, "/question-reports/").concat(questionReportId, "/bookmark");
                _context3.next = 4;
                return this.axios.patch(_updateQuestionReportBookmark2);

              case 4:
                jsonResponse = _context3.sent;
                return _context3.abrupt("return", Result.ok(jsonResponse.data));

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function updateQuestionReportBookmark(_x4, _x5) {
        return _updateQuestionReportBookmark.apply(this, arguments);
      }

      return updateQuestionReportBookmark;
    }()
  }]);

  return ReportApi;
}(AxiosApi);